interface VisibilityContent {
    is_active?: boolean | number;
    custom_published_at?: string | null;
}

export function isContentVisible(content: VisibilityContent) {
    const active = content.is_active === true || content.is_active === 1;
    if (!active) return false;
    if (!content.custom_published_at) return true;

    const scheduledAt = new Date(content.custom_published_at).getTime();
    if (Number.isNaN(scheduledAt)) return true;

    return scheduledAt <= Date.now();
}
